import { ADS_PATH } from "./adsCopy";

export const ADS_TOUR_STORAGE_KEY = "sm-ads-tour-dismissed";

export const ADS_TOUR = {
    start: "Show me around",
    skip: "Skip",
    next: "Next",
    back: "Back",
    done: "Done",
    dismiss: "Don't show again",
};

export const adsTourSteps = (visibleTabNames = []) =>
    ADS_PATH.filter((item) => visibleTabNames.includes(item.tab));

export const nextAdsTourIndex = (index, total) => Math.min(index + 1, Math.max(total - 1, 0));

export const prevAdsTourIndex = (index) => Math.max(index - 1, 0);

export const isLastAdsTourStep = (index, total) => total > 0 && index >= total - 1;

export const adsTourProgress = (index, total) => `Step ${index + 1} of ${total}`;

export const readAdsTourDismissed = () => {
    try {
        return localStorage.getItem(ADS_TOUR_STORAGE_KEY) === "1";
    } catch {
        return false;
    }
};

export const writeAdsTourDismissed = () => {
    try {
        localStorage.setItem(ADS_TOUR_STORAGE_KEY, "1");
    } catch {
        /* ignore quota / private mode */
    }
};
